// @vue/component
export default {
  props: {
    errorHeading: {
      type: String,
      required: true,
    },
    errorIcon: {
      type: String,
      default: 'far fa-times-circle',
    },
    errorText: {
      type: String,
      default: '',
    },
    actionButtonLabel: {
      type: String,
      default: '',
    },
    action: {
      type: Function,
      default: () => '',
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    showAsBottomSheet() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    showing: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit('update:visible', value);
      },
    },
  },
};
